import { render, staticRenderFns } from "./Poisonous.vue?vue&type=template&id=0b7b11de&scoped=true"
import script from "./Poisonous.vue?vue&type=script&lang=js"
export * from "./Poisonous.vue?vue&type=script&lang=js"
import style0 from "./Poisonous.vue?vue&type=style&index=0&id=0b7b11de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b11de",
  null
  
)

export default component.exports